// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"482":"718145fef3ef1da2","1116":"2c7dcd7990736d6f","1698":"2ac005cf8381b53e"}[chunkId] + ".css";
};